import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';
import { Tenant } from '../../../types/tenant';

interface OwnProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (tenantId: string) => void;
  tenant?: Tenant;
}

const DeleteConfirmationDialog = ({ open, onClose, onConfirm, tenant }: OwnProps) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete tenant</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete {tenant?.name}? 
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant='modal'>
          Cancel
        </Button>
        <Button onClick={() => onConfirm(tenant?.tenantId!)} color="error" variant="modal">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;